<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}
// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      tableData: [],
      title: "選手管理",
      items: [
        {
          text: "Game",
          href: "/",
        },
        {
          text: "選手管理",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      search_school_code: "",
      search_sex: "", // 性別検索用
      school_code: "",
      no: "",
      name: "",
      sex: 0,
      school_year: null,
      id: null,
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: ["school_code", "school_name", "no", "name", "sex", "school_year"],
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "school_code",
          label: "学校コード",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "school_name",
          label: "学校名",
          sortable: true,
          tdClass: "minWidth150",
        },
        {
          key: "no",
          label: "学籍番号",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "name",
          label: "氏名",
          sortable: true,
          tdClass: "minWidth150",
        },
        {
          key: "sex",
          label: "性別",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "school_year",
          label: "学年",
          sortable: true,
          tdClass: "minWidth100",
        },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      mode: "list",
      schoolList: [],
      search_area_code: "", // 地区コード検索用
      areaList: [{ value: "", text: "" }], // 地区リスト
    };
  },
  mounted() {
    let roles = this.$store.getters.roles;
    if (roles == "admin") {
      this.getUser("admin");
    } else if (roles == "user") {
      this.getUser("user");
      this.search_school_code = this.$store.getters.schoolCode;
    } else {
      window.location.href = "/";
      return;
    }
    this.searchItems();
  },
  computed: {
    rows() {
      return this.filterItems.length;
    },
  },
  methods: {
    // 検索
    searchItems() {
      this.loading = true;
      axios
        .get("/api/players", {
          params: {
            area_code: this.search_area_code, // 地区コードをAPIに渡す
            school_code: this.search_school_code,
            sex: this.search_sex
          }
        })
        .then((response) => {
          this.loading = false;
          const players = response.data.players;
          const schools = response.data.schools ?? [];
          const areas = response.data.areas ?? [];
          this.tableData = players.map((item) => ({
            ...item,
            sex: item.sex ?? 0,
            school_year: item.school_year ?? "",
          }));
          this.filterItems = this.tableData;
          this.selectAll = false;
          // 地区リストをセット
          this.areaList = [
            { value: "", text: "" },
            ...areas.map(a => ({
              value: a.code,
              text: a.code + " : " + a.name,
            }))
          ];
          // 学校リストをセット
          this.schoolList = [
            { value: "", text: "" },
            ...schools.map(s => ({
              value: s.school_code,
              text: s.school_code + " : " + s.school_name,
            }))
          ];
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      axios
        .post("/api/players/delete", {
          ids: ids,
        })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 追加
    add() {
      this.mode = "add";
      this.id = "new";
      this.school_code = this.search_school_code;
      this.no = "";
      this.name = "";
      this.sex = 0;
      this.school_year = null;
    },
    // 編集
    edit(item) {
      this.mode = "edit";
      this.id = item.id;
      this.school_code = item.school_code;
      this.no = item.no;
      this.name = item.name;
      this.sex = item.sex;
      this.school_year = item.school_year;
    },
    // 確定
    submit() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("school_code", this.school_code);
      // 空文字の場合はnullを送る
      formData.append("no", this.no ?? "");
      formData.append("name", this.name);
      formData.append("sex", this.sex);
      formData.append("school_year", this.school_year);
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.loading = true;
      axios
        .post("/api/players/update", formData, config)
        .then((res) => {
          this.loading = false;
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      this.filterItems = items;
    },
    exportPlayers() {
      // 学校コードが未選択の場合はエラー表示して処理中断
      if (!this.search_school_code) {
        this.$toasted.error("学校コードを選択してください");
        this.loading = false;
        return;
      }
      this.loading = true;
      axios
        .get("/api/players/export/list", {
          params: {
            school_code: this.search_school_code,
            sex: this.search_sex,
          },
          responseType: "blob", // バイナリデータを取得
        })
        .then((response) => {
          this.loading = false;
          let fileName = "選手一覧.xlsx";
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    importPlayers(event) {
      const file = event.target.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("school_code", this.search_school_code);

      this.loading = true;
      axios
        .post("/api/players/import", formData, {
          headers: { "content-type": "multipart/form-data" },
        })
        .then(() => {
          this.loading = false;
          this.searchItems();
          this.$toasted.success("インポートが完了しました");
          // ★ここでinputの値をリセット
          event.target.value = "";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
          // ★エラー時もリセット
          event.target.value = "";
        });
    },
  },
  watch: {
    selectAll: function (newValue, oldValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
  },
};
</script>
<style>
.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-sm-12 col-md-4" v-if="$store.getters.roles !== 'user'">
                <b-form-group label="地区コード" label-cols-sm="3">
                  <b-form-select
                    v-model="search_area_code"
                    :options="areaList"
                    @change="searchItems"
                    class="form-select"
                    style="width: 200px"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-4">
                <b-form-group label="学校コード" label-cols-sm="3">
                  <b-form-select
                    v-model="search_school_code"
                    :options="schoolList"
                    @change="searchItems"
                    class="form-select"
                    :disabled="$store.getters.roles === 'user'"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-4">
                <b-form-group label="性別" label-cols-sm="3">
                  <b-form-select v-model="search_sex" :options="[
                    { value: '', text: '' },
                    { value: 1, text: '男子' },
                    { value: 2, text: '女子' }
                  ]" @change="searchItems" class="form-select" style="width: 100px"></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="fields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(sex)="{ item }">
                  <span>
                    {{ item.sex === 1 ? "男子" : item.sex === 2 ? "女子" : "" }}
                  </span>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span><button class="btn btn-sm btn-outline-primary" @click="edit(item)">
                      編集
                    </button></span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete>
                    削除
                  </button>
                  <button class="btn btn-primary me-3" type="button" @click="add">
                    追加
                  </button>
                  <button class="btn btn-success me-2" type="button" @click="exportPlayers">
                    選手一覧出力
                  </button>
                  <label class="btn btn-success me-2 mt-2">
                    選手一覧取込み
                    <input type="file" @change="importPlayers" style="display: none" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 追加・編集 -->
    <div class="row" v-if="mode == 'add' || mode == 'edit'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ mode == "add" ? "新規登録" : "編集" }}
            </h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group label="学校コード" label-cols-sm="3">
                      <ValidationProvider name="学校コード" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select
                            v-model="school_code"
                            :options="schoolList"
                            placeholder="学校を選択"
                            class="form-select"
                            style="width: 200px"
                            :disabled="$store.getters.roles === 'user'"
                          ></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="学籍番号" label-cols-sm="3">
                      <ValidationProvider name="学籍番号" :rules="{ required: false }">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="text" style="width: 100px" v-model="no" autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="氏名" label-cols-sm="3">
                      <ValidationProvider name="氏名" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="text" style="width: 200px" v-model="name"
                            autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="性別" label-cols-sm="3">
                      <ValidationProvider name="性別" :rules="{ required: false }">
                        <div slot-scope="ProviderProps">
                          <b-form-select plain v-model="sex"
                            :options="[{ value: 0, text: '' }, { value: 1, text: '男子' }, { value: 2, text: '女子' }]"
                            style="width: 100px"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="学年" label-cols-sm="3">
                      <ValidationProvider name="学年" :rules="{ required: true, regex: /^[1-9]$/ }">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="number" style="width: 100px" v-model="school_year"
                            autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submit">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
